import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { projekte } from "../helper/data";
import { Link } from "react-router-dom";

const Projekte = () => {
  const [isVisible, setIsVisible] = useState(false);

  // 3 sn sonra animasyonları aç
  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 1000);
    return () => clearTimeout(timer);
  }, []);

  const containerVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { delay: 0.3, duration: 0.5, type: "spring", stiffness: 120 },
    },
  };

  const leftInfo = projekte.slice(0, 3); // İlk 3 resim
  const rightInfo = projekte.slice(-3); // Son 3 resim

  // Ortak Overlay Component
  const CardOverlay = ({ title, desc, large = false }) => (
    <div
      className="position-absolute top-0 start-0 w-100 h-100 d-flex flex-column align-items-center justify-content-center text-center"
      style={{
        pointerEvents: "none",
        background: "rgba(0,0,0,0.4)", // hafif karartma
      }}
    >
      {large ? (
        <>
          <h1
            className="text-warning"
            style={{
              textTransform: "capitalize",
              textShadow: "0 2px 8px rgba(0,0,0,0.6)",
            }}
          >
            {title}
          </h1>
          <p
            className="fs-2 text-white"
            style={{ textShadow: "0 2px 8px rgba(0,0,0,0.6)" }}
          >
            {desc}
          </p>
        </>
      ) : (
        <>
          <h3
            className="text-warning"
            style={{ textShadow: "0 2px 6px rgba(0,0,0,0.6)" }}
          >
            {title}
          </h3>
          <p
            className="text-white"
            style={{ textShadow: "0 2px 6px rgba(0,0,0,0.6)" }}
          >
            {desc}
          </p>
        </>
      )}
    </div>
  );

  return (
    <div className="container-fluid py-5 mb-5 border-bottom border-3 border-success shadow-lg">
      <div className="text-center mb-5">
        <h1 className="text-dark shadow-text">Projekte</h1>
      </div>

      <div className="row">
        <div className="col-xxl-10 offset-xxl-1 mx-auto">
          <div className="row">
            {/* Sol Sütun */}
            <div className="col-lg-3 order-2 order-lg-1">
              {leftInfo.map((info, index) => (
                <motion.div
                  key={info.id ?? index}
                  variants={containerVariants}
                  initial="hidden"
                  whileInView={isVisible ? "visible" : "hidden"}
                  viewport={{ once: true, amount: 0.5 }}
                >
                  <Link
                    to={
                      info.id === 1
                        ? "/bilderVonHeimat"
                        : info.id === 2
                          ? "/engagementHarmonie"
                          : info.id === 3
                            ? "/demokratie"
                            : `/projekt/${info.id}`
                    }
                    className="custom-link text-decoration-none"
                  >
                    <div className="card project-card mb-4 position-relative overflow-hidden">
                      <motion.img
                        src={info.image}
                        alt={`Foto ${index + 1}`}
                        className="w-100"
                        height={200}
                        style={{ objectFit: "cover", display: "block" }}
                        whileHover={{ scale: 1.05 }}
                        transition={{ duration: 0.3 }}
                      />
                      <CardOverlay title={info.titel} desc={info.desc} />
                    </div>
                  </Link>
                </motion.div>
              ))}
            </div>

            {/* Middle Column - Big Card */}
            <div className="col-lg-6 order-1 order-lg-2">
              <motion.div
                variants={containerVariants}
                initial="hidden"
                whileInView={isVisible ? "visible" : "hidden"}
                viewport={{ once: true, amount: 0.5 }}
              >
                <Link
                  to="/anschubfoerderung"
                  className="custom-link text-decoration-none"
                >
                  <div className="card project-card mb-4 position-relative overflow-hidden">
                    <motion.img
                      src={projekte[3].image}
                      alt="Foto 4"
                      className="w-100"
                      height={650}
                      style={{ objectFit: "cover", display: "block" }}
                      whileHover={{ scale: 1.05 }}
                      transition={{ duration: 0.3 }}
                    />
                    <CardOverlay
                      title={projekte[3].titel}
                      desc={projekte[3].desc}
                      large
                    />
                  </div>
                </Link>
              </motion.div>
            </div>

            {/* Right Column */}
            <div className="col-lg-3 order-3 order-lg-3">
              {rightInfo.map((info, index) => (
                <motion.div
                  key={info.id ?? index}
                  variants={containerVariants}
                  initial="hidden"
                  whileInView={isVisible ? "visible" : "hidden"}
                  viewport={{ once: true, amount: 0.5 }}
                >
                  <Link
                    to={
                      info.titel === "Engagement Global"
                        ? "/engagementGlobale"
                        : `projekt/${info.id}`
                    }
                    className="custom-link text-decoration-none"
                  >
                    <div className="card project-card mb-4 position-relative overflow-hidden">
                      <motion.img
                        src={info.image}
                        alt={`Foto ${index + 1}`}
                        className="w-100"
                        height={200}
                        style={{ objectFit: "cover", display: "block" }}
                        whileHover={{ scale: 1.05 }}
                        transition={{ duration: 0.3 }}
                      />
                      <CardOverlay title={info.titel} desc={info.desc} />
                    </div>
                  </Link>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Projekte;
